import { ElementRef, Injectable, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { ANALYTICS_EVENTS_LOGIN } from '../../data-access/login-modal/constants/analytics-constants';
import {
  STANDALONE_PAGE_URL,
  VIEW_NAME
} from '../../data-access/login-modal/constants/login-constant';
import { FacadeService } from '../../data-access/login-modal/facade/facade.service';
import { ForgotLoginFacadeService } from '../../data-access/login-modal/facade/forgot-login-facade/forgot-login-facade.service';
import { ResetPasswordFacade } from '../../data-access/login-modal/facade/reset-password/reset-password.facade';
import { NextDisplayViewService } from '../../data-access/login-modal/services';
import { WifiPortalService } from '../../data-access/login-modal/services/wifi-portal/wifi-portal.service';

@Injectable({
  providedIn: 'root'
})
export class LoginModalHelperSuperSupportComponent {
  loadSpinner = false;
  totalHeight = 0;

  constructor(
    public facade: FacadeService,
    protected renderer: Renderer2,
    public nextDisplayViewService: NextDisplayViewService,
    public forgotLoginFacade: ForgotLoginFacadeService,
    public router: Router,
    public resetPasswordFacade: ResetPasswordFacade,
    protected wifiPortalService: WifiPortalService,
    protected analytics: AnalyticsService
  ) {}

  setStyleForStandaloneHelper(loginModalNative: ElementRef) {
    const navbar = document.querySelector('.navbar');
    const loginModalDiv = document.querySelector('.login-modal-container');
    this.renderer.setStyle(navbar, 'position', 'relative');
    this.renderer.setStyle(navbar, 'flex-wrap', 'nowrap');
    this.renderer.setStyle(loginModalNative, 'top', '0');
    this.renderer.setStyle(
      loginModalNative,
      'margin-top',
      `${this.totalHeight}px`
    );
    this.renderer.setStyle(loginModalDiv, 'max-height', 'none');
  }

  setLoaderForStandAlone() {
    document.addEventListener('DOMContentLoaded', () => {
      const loading = document.querySelector('.idp-loader__loading');
      const overlay = document.querySelector('.idp-loader__overlay');
      const loader = document.querySelector('.login-loader');
      const wrapper = document.querySelector('.login-modal-container');
      this.renderer.setStyle(overlay, 'right', '0');
      this.renderer.setStyle(overlay, 'width', '100vw');
      this.renderer.setStyle(overlay, 'margin', 'auto');
      this.renderer.setStyle(overlay, 'top', '0');
      this.renderer.setStyle(loading, 'margin', 'auto');
      this.renderer.setStyle(loading, 'z-index', '2001');
      this.renderer.setStyle(loading, 'left', '0');
      this.renderer.setStyle(loading, 'right', '0');
      this.renderer.setStyle(loading, 'position', 'fixed');
      this.renderer.setStyle(loader, 'position', 'absolute');
      this.renderer.setStyle(wrapper, 'overflow', 'hidden');
    });
  }

  toggleModalHelper() {
    const loginModalDiv = document.querySelector('.login-modal-container');
    const body = document.body;
    if (loginModalDiv && loginModalDiv.classList.contains('d-none')) {
      loginModalDiv.classList.remove('d-none');
      this.displayNextScreen(VIEW_NAME.LOGIN_CREDENTIALS_SCREEN);
      this.resetPasswordFacade.resetForm();
    } else {
      if (this.loadSpinner) {
        return;
      }
      loginModalDiv?.classList.add('d-none');
      this.renderer.removeClass(body, 'modal-open');
      this.facade.resetForm();
      this.facade?.formAlertDisplay();
      this.focusLoginHeaderButton();
    }
  }

  focusTab(focusable: HTMLElement[], e: KeyboardEvent) {
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const shift = e.shiftKey;
    if (shift) {
      if (e.target === first) {
        last.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === last) {
        first.focus();
        e.preventDefault();
      }
    }
  }

  accountRecoveryAnalytics(viewName: string) {
    if (viewName === VIEW_NAME.FORGOT_LOGIN_SCREEN) {
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.FORGOT_LOGIN_LOADED,
        true
      );
    } else if (viewName === VIEW_NAME.RESET_PASSWORD_SCREEN) {
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.RESET_PASSWORD_LOADED,
        true
      );
    } else {
      return;
    }
  }

  displayNextScrenHelper(viewName: string): void {
    if (viewName === VIEW_NAME.RESET_PASSWORD_SCREEN) {
      this.resetPasswordFacade.getResetPasswordPageContent();
    }
  }

  displayNextScreen(viewName: string): void {
    if (!this.facade.standalonePage) {
      this.displayNextScrenHelper(viewName);
      this.nextDisplayViewService.nextDisplayView(viewName);
      this.accountRecoveryAnalytics(viewName);
    } else {
      if (this.wifiPortalService.getQueryParamsWFP().isWFP) {
        this.wifiPortalService.getRefreshUrlWFP(true);
        return;
      }
      this.router.navigateByUrl(`/${STANDALONE_PAGE_URL[viewName]}`);
    }
  }

  focusLoginHeaderButton() {
    const loginHeaderButton = document.getElementById('login-modal-button');
    loginHeaderButton?.focus();
  }
}
